import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { EBadgePosition } from 'utils/enums';

const badgePositionController: Record<EBadgePosition, any> = {
  [EBadgePosition.BOTTOM_CENTER]: {
    left: '50%',
    bottom: '-8px',
    right: 'unset',
    top: 'unset',
    isCentered: true,
  },
  [EBadgePosition.BOTTOM]: {
    left: '50%',
    bottom: '0px',
    right: 'unset',
    top: 'unset',
    isCentered: true,
  },
  [EBadgePosition.BOTTOM_LEFT]: {
    left: '-8px',
    bottom: '-8px',
    right: 'unset',
    top: 'unset',
  },
  [EBadgePosition.BOTTOM_RIGHT]: {
    left: 'unset',
    bottom: '-8px',
    right: '-8px',
    top: 'unset',
  },
  [EBadgePosition.TOP_CENTER]: {
    left: '50%',
    bottom: 'unset',
    right: 'unset',
    top: '0px',
    isCentered: true,
  },
  [EBadgePosition.CENTER]: {
    left: '50%',
    bottom: 'unset',
    right: 'unset',
    top: '0px',
    isCentered: true,
  },
  [EBadgePosition.TOP]: {
    left: '50%',
    bottom: 'unset',
    right: 'unset',
    top: '-8px',
    isCentered: true,
  },
  [EBadgePosition.TOP_LEFT]: {
    left: '-8px',
    bottom: 'unset',
    right: 'unset',
    top: '-8px',
  },
  [EBadgePosition.LEFT]: {
    left: '-8px',
    bottom: 'unset',
    right: 'unset',
    top: '-8px',
    isCentered: true,
  },
  [EBadgePosition.TOP_RIGHT]: {
    left: 'unset',
    bottom: 'unset',
    right: '-8px',
    top: '-8px',
  },
  [EBadgePosition.RIGHT]: {
    left: 'unset',
    bottom: 'unset',
    right: '-8px',
    top: '-8px',
  },
  [EBadgePosition.CENTER_CENTER]: {
    left: '50%',
    bottom: 'unset',
    right: 'unset',
    top: '50%',
    isCentered: true,
  },
};

export const StyledCornerBadge = styled.div`
  height: 64px;
  width: 64px;
  position: absolute;
  top: ${(props: any) =>
    badgePositionController[props.position as EBadgePosition]?.top};
  left: ${(props: any) =>
    badgePositionController[props.position as EBadgePosition]?.left};
  right: ${(props: any) =>
    badgePositionController[props.position as EBadgePosition]?.right};
  bottom: ${(props: any) =>
    badgePositionController[props.position as EBadgePosition]?.bottom};
  background: ${(props: any) => props.background};
  background-size: cover;
  z-index: 1;

  .sale-amount {
    align-items: center;
    height: 64px;
    width: 100%;
    position: relative;
    transform: rotateZ(45deg);
  }

  p {
    background: ${(props: any) =>
      props.textColor ? createGradientOrSolid(props.textColor) : 'unset'};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: white;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -65%);
    padding: 0 10px;
  }

  &.small {
    height: 40px;
    width: 40px;
    top: -3px;
    right: -3px;

    .sale-amount {
      height: 40px;
    }

    p {
      font-size: 10px;
      top: 35%;
      padding: 0 5px;
    }
  }
` as any;

export const StyledMiddleBadge = styled.div`
  width: 72%;
  aspect-ratio: 9/2;
  max-width: 100px;
  position: absolute;
  min-height: auto;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  background: ${(props: any) => props.background};
  background-size: cover;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
    font-size: 10px;
    font-weight: 600;
    color: white;
    margin-bottom: 2px;
    background: ${(props: any) =>
      props.textColor ? createGradientOrSolid(props.textColor) : 'unset'};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;

    &:after {
      background: none;
      content: attr(data-text);
      left: 0;
      top: 0;
      z-index: -1;
      position: absolute;
      text-shadow: 0 1px 1px #000000;
    }
  }
  
  & .autoResizedText {
    width: 100%;
    text-align: center;
  }

  @media (max-width: 350px) {
    p {
      font-size: 8px;
    }
  }
  @media (min-width: 450px) {
    top: -4px;
    p {
      font-size: 13px;
    }
  }
  @media (min-width: 600px) {
    top: -5px;
  }
` as any;
